export default __webpack_public_path__ + "static/media/BrainBreak cards96.7730c685.png";